import React from "react";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useFormContext } from "react-hook-form";
import { GridLegacy } from "@mui/material";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";

function Zones() {
  const { vestigingId } = useFormContext();

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <FormAsyncTC
              async={{
                url:
                  "core/zones/search?fields=id as value, zoneName as label&per_page=50&sort_field=zoneName&vestiging_id=" +
                  vestigingId,
                searchField: "zoneName",
              }}
              key={"zones" + vestigingId}
              multiple={true}
              name={"zones"}
              tDefault={"Zone selection"}
              tKey={"producten.form.menu.label.zoneSelection"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Zones;
